import { render, staticRenderFns } from "./subeventOrders.vue?vue&type=template&id=78ed1a34&"
import script from "./subeventOrders.vue?vue&type=script&lang=js&"
export * from "./subeventOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports